import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";
// import { IOrganization } from "../organizationModel";

export const getRenewHistory = createAsyncThunk(
  "Company/GetCompanyHistory",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Company/GetCompanyHistory`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertCompanyInfo = createAsyncThunk(
  "Company/InsertCompanyInfo",
  async (BranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Company/InsertCompanyInfo`,
        BranchData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating branch:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCompanyDetails = createAsyncThunk(
  "Company/GetCompanyInfoDetails",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Company/GetCompanyInfoDetails`
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        RegistrationDate: result?.RegistrationDate
          ? moment(result?.RegistrationDate, "YYYY-MM-DD").toDate()
          : "",
        CompanyName: result?.CompanyName,
        GSTNo: result?.GSTNo,
        Address: result?.Address,
        CityID: result?.CityID,
        CityName: result?.CityName,
        StateID: result?.StateID,
        StateName: result?.StateName,
        ContactPerson: result?.ContactPerson,
        EmailID: result?.EmailID,
        MobileNo: result?.MobileNo,
        TotalUser: result?.TotalUser,
        PaymentType: result?.PaymentType,
        Amount: result?.Amount,
        ExpiryDate: result?.ExpiryDate
          ? moment(result?.ExpiryDate, "YYYY-MM-DD").toDate()
          : "",
        CreatedBy: result?.CreatedBy,
        CreatedDate: result?.CreatedDate
          ? moment(result?.CreatedDate, "YYYY-MM-DD").toDate()
          : "",
      };
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertRenewForm = createAsyncThunk(
  "Company/InsertRenewCompanyInfo",
  async (BranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Company/InsertRenewCompanyInfo`,
        BranchData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateRenewForm = createAsyncThunk(
  "Company/UpdateRenewCompanyInfo",
  async (BranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Company/UpdateRenewCompanyInfo`,
        BranchData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getRenewDetails = createAsyncThunk(
  "Company/FindByIDRenewCompanyInfo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Company/FindByIDRenewCompanyInfo`,
        {
          ID: ID,
        }
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        RenewDate: result?.RenewDate
          ? moment(result?.RenewDate, "YYYY-MM-DD").toDate()
          : "",
        TotalUser: result?.TotalUser,
        PaymentType: result?.PaymentType,
        Amount: result?.Amount,
        Remarks: result?.Remarks,
      };
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
